import { render } from "./PatientTransferForm.vue?vue&type=template&id=db9387ea&scoped=true"
import script from "./PatientTransferForm.vue?vue&type=script&lang=js"
export * from "./PatientTransferForm.vue?vue&type=script&lang=js"

import "./PatientTransferForm.vue?vue&type=style&index=0&id=db9387ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db9387ea"]])

export default __exports__